export default __webpack_public_path__ + "static/media/play-now.4d00507c.jpg";